import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const MergeCells = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.50006 2C2.22392 2 2.00006 2.22386 2.00006 2.5L2.00006 5.54268C1.70876 5.64564 1.50006 5.92345 1.50006 6.25V9.75C1.50006 10.0766 1.70876 10.3544 2.00006 10.4573V13.5C2.00006 13.7761 2.22392 14 2.50006 14H13.5001C13.7762 14 14.0001 13.7761 14.0001 13.5V10.4573C14.2914 10.3544 14.5001 10.0766 14.5001 9.75V6.25C14.5001 5.92345 14.2914 5.64564 14.0001 5.54268V2.5C14.0001 2.22386 13.7762 2 13.5001 2H2.50006ZM13.0001 3L8.50006 3L8.50006 5.5H13.0001V3ZM7.50006 3H3.00006V5.5H7.50006V3ZM3.00006 9L3.00006 7H8.00006H13.0001V9H7.96539L7.961 8.99998L7.95661 9H3.00006ZM13.0001 10.5V13H8.42194V10.5H13.0001ZM7.50006 10.5H3.00006V13H7.50006V10.5Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default MergeCells
